<template>
  <AModal
    modal-class="d-amazon-store-selection text-black-base"
  >
    <div class="overlay" />

    <div class="modal-content">
      <div class="modal-header">
        <h4>Buy it now</h4>
        <a
          class="button button-yellow button-icon button-close-white button-close-modal"
          @click="dismiss"
        />
      </div>

      <div
        class="modal-body loadable"
        :class="{ 'loading': vm.isProcessing }"
      >
        <div
          v-if="vm.isProcessing"
          class="loading-content"
        >
          <DuiLoadingIndicator size="lg" />
          <p class="space-top-2em">
            Saving your preference...
          </p>
        </div>

        <div class="loaded-content">
          <h3>
            <strong>Choose your preferred Amazon store</strong>
          </h3>
          <p class="large space-bottom-4em">
            We'll remember your preference in the future. If you need to
            update it, you can do so from your
            <a
              :href="vm.accountSettingsUrl"
              title="Account settings"
            >account settings</a>.
          </p>

          <div
            v-if="storesList"
            class="store-picker"
          >
            <a
              v-for="(store, index) in storesList"
              :key="index"
              class="store-option"
              @click="storePicked(store)"
            >
              <span class="emoji">
                {{ store.emoji }}
              </span>
              <span class="name">
                {{ store.text }}
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </AModal>
</template>

<script>
import Vue from 'vue';

import AModal from '@d-components/a-modal/a-modal.vue';
import accountSettingsService from '@d-services/account-settings-service/account-settings-service';
import amazonStoresService from '@d-services/amazon-stores-service/amazon-stores-service';
import URLS from '@d-shared/urls/urls';
import { getErrorMessage } from '@d-shared/utils/errors';

export default {
  components: {
    AModal,
  },
  props: {
    bookSlug: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    vm: {
      accountSettingsUrl: URLS.app.accountSettings,
      isProcessing: false,
    },
  }),
  computed: {
    storesList() {
      return this.$store.getters['AmazonStore/get-stores-list'];
    },
  },
  mounted() {
    this.$store.dispatch('AmazonStore/loadStoresList');
  },
  methods: {
    dismiss() {
      this.$emit('dismiss');
    },

    async storePicked(store) {
      this.$set(this.vm, 'isProcessing', true);

      try {
        const accountSettingsData = {
          user: {
            profile_attributes: {
              amazon_store: store.value,
            },
          },
        };

        await accountSettingsService.saveAccountSettings(accountSettingsData);
        const amazonUrl = await amazonStoresService.getBookAmazonUrl(this.bookSlug);
        this.$emit('amazon-store-picked', amazonUrl);
      } catch (error) {
        Vue.duiNotificationManager.error(getErrorMessage(error));
      }

      this.$set(this.vm, 'isProcessing', false);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.d-amazon-store-selection {
  .store-picker {
    margin: -$_1em;
    text-align: center;

    @include screenMoreThan(sm) {
      text-align: left;
    }

    .store-option {
      background-color: getColor($grey, faint);
      border: $border-width-base solid transparent;
      border-radius: $border-radius-base;
      color: getColor($black);
      display: inline-block;
      font-weight: $base-weight-bold;
      margin: $_1em;
      padding: $_2em 30px;
      text-align: center;

      @include transition((
        background-color,
        border-color,
        box-shadow
      ));

      &:hover {
        background-color: getColor($white);
        border-color: getColor($yellow, medium);
        box-shadow: $box-shadow-sm;
      }

      .emoji {
        font-size: $_6em;
        line-height: $_5em;
      }

      .name {
        display: block;
      }
    }
  }
}
</style>
